export const normalizePhone = (phone) => {

    let finalPhone = phone.trim();

    if (/^09\d{9}$/.test(finalPhone)) {
        finalPhone = `+98${finalPhone.substring(1)}`;
    } else if (/^9\d{9}$/.test(finalPhone)) {
        finalPhone = `+98${finalPhone}`;
    } else if (/^\+98\d{10}$/.test(finalPhone)) {
        // معتبره، همونو نگه می‌داریم
    } else {
        throw new Error("شماره موبایل معتبر نیست. مثال: 09123456789 یا 9123456789");
    }

    return finalPhone;
};
